export default __webpack_public_path__ + "static/media/flower_10000.0a5958c5.jpg";